import store from '@js/store';
import { abortIfNotPermitted } from '../utils';

const redirectIfModuleNotLoaded = next => {
    if (!store.hasModule('myaccount')) {
        next('/');
    }
};

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted('franchise_view_account', next);
        },
    },
    {
        path: '/plans',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account-subscribe.vue'),
        beforeEnter: (to, from, next) => {
            redirectIfModuleNotLoaded(next);

            const isInTrial =
                store.getters['myaccount/hasSubscription'] &&
                (store.getters['myaccount/statusIsInTrial'] ||
                    store.getters['myaccount/trialIsExpired']);

            if (isInTrial) {
                return abortIfNotPermitted('franchise_manage_account', next);
            }

            return next('/');
        },
    },
    {
        path: '/update-subscription',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account-update-plan.vue'),
        beforeEnter: (to, from, next) => {
            redirectIfModuleNotLoaded(next);

            const subscriptionNotInTrialAndActive =
                store.getters['myaccount/hasSubscription'] &&
                store.getters['myaccount/isAutoCollection'] &&
                !store.getters['myaccount/isPriceOverride'] &&
                (store.getters['myaccount/statusIsActive'] &&
                    !store.getters['myaccount/isCurrentTermEnded']);

            if (subscriptionNotInTrialAndActive) {
                return abortIfNotPermitted('franchise_manage_account', next);
            }

            return next('/');
        },
    },
    {
        path: '/billing-history',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account-billing.vue'),
    },
    {
        path: '/franchise',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account-update-franchise.vue'),
        beforeEnter: (to, from, next) => {
            redirectIfModuleNotLoaded(next);
            return abortIfNotPermitted('franchise_manage_account', next);
        },
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/route-components/myaccount.js